// src/components/manuscript/ElementToggle.jsx
//
// The include/exclude switch on a manuscript structure element.
//
// There is exactly one of these on the page. It used to render per row in the
// dark element column as well, which meant two controls writing the same
// `enabled` flag and a row whose click target competed with the switch inside
// it. The row now only selects; this switch, in the detail pane, is what turns
// the element on and off. The list still shows the state — a disabled row is
// dimmed and struck through.
//
// Hand-rolled rather than a MUI Switch so the size and the gold/purple palette
// match the rest of the page.
import React from 'react';
import { Box } from '@mui/material';
import { SP } from './structureTokens';

export default function ElementToggle({ on, onChange, label }) {
  return (
    <Box
      component="button"
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      onClick={() => onChange?.(!on)}
      sx={{
        flexShrink: 0,
        width: 44,
        height: 24,
        p: 0,
        border: 'none',
        borderRadius: '999px',
        position: 'relative',
        cursor: 'pointer',
        transition: 'background-color .2s ease',
        backgroundColor: on ? SP.gold : SP.lineSoft,
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 3,
          left: 3,
          width: 18,
          height: 18,
          borderRadius: '50%',
          transition: 'transform .2s ease',
          transform: on ? 'translateX(20px)' : 'none',
          backgroundColor: on ? SP.purpleDeep : SP.white,
        },
        '&:focus-visible': {
          outline: `2px solid ${SP.goldLight}`,
          outlineOffset: 2,
        },
      }}
    />
  );
}
